import { render, staticRenderFns } from "./Encgeneral.vue?vue&type=template&id=0b00fa8e&scoped=true"
import script from "./Encgeneral.vue?vue&type=script&lang=js"
export * from "./Encgeneral.vue?vue&type=script&lang=js"
import style0 from "./Encgeneral.vue?vue&type=style&index=0&id=0b00fa8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00fa8e",
  null
  
)

export default component.exports